module.exports = __webpack_public_path__ + "img/girl5.2adb12d3.jpg";